import React from 'react';
export var FormLayout = function FormLayout(props) {
  return /*#__PURE__*/React.createElement("form", null, props.fields.toList(), props.error, props.buttons);
};